export default class DtoProtection {
    constructor(obj) {
        this.idStation = obj.idStation
        this.system = obj.system
        this.protectionType = obj.protectionType
        this.placing = obj.placing
        this.unlockMode = obj.unlockMode
        this.comment = obj.comment
    }
}